function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
import SVG from "../../layouts/SVG.js";
export var Fees = function Fees(props) {
  return /*#__PURE__*/React.createElement(SVG, _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z",
    fill: "#E9F6F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7.9375V8.875",
    stroke: "#0C9AB0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15.125V16.0625",
    stroke: "#0C9AB0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1875 10.4375C14.1875 10.2323 14.1471 10.0291 14.0686 9.83956C13.99 9.64999 13.8749 9.47774 13.7299 9.33265C13.5848 9.18755 13.4125 9.07246 13.2229 8.99394C13.0334 8.91542 12.8302 8.875 12.625 8.875H11.2188C10.8043 8.875 10.4069 9.03962 10.1139 9.33265C9.82087 9.62567 9.65625 10.0231 9.65625 10.4375C9.65625 10.8519 9.82087 11.2493 10.1139 11.5424C10.4069 11.8354 10.8043 12 11.2188 12H12.9375C13.3519 12 13.7493 12.1646 14.0424 12.4576C14.3354 12.7507 14.5 13.1481 14.5 13.5625C14.5 13.9769 14.3354 14.3743 14.0424 14.6674C13.7493 14.9604 13.3519 15.125 12.9375 15.125H11.0625C10.6481 15.125 10.2507 14.9604 9.95765 14.6674C9.66462 14.3743 9.5 13.9769 9.5 13.5625",
    stroke: "#0C9AB0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};